"use client";
import React from "react";
import styled from "styled-components";
import Link from "next/link";
// import { graphql } from "gatsby"

import sites from "./websites.json";

// import { StaticImage, getImage } from "gatsby-plugin-image"
const Container = styled.div`
  display: grid;
  grid-column-gap: 5px;
  margin-bottom: 100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
  position: relative;

  @media only screen and (min-width: 850px) {
    grid-template-columns: repeat(9, 100px);
    width: 830px;
  }
  @media only screen and (max-width: 850px) {
    grid-template-columns: repeat(6, 100px);
    width: 620px;
  }
  @media only screen and (max-width: 720px) {
    grid-template-columns: repeat(4, 100px);
    width: 410px;
  }
  @media only screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 100px);
    width: 100%;
  }
  @media only screen and (max-width: 400px) {
    column-gap: 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }
`;
const SiteItem = styled.div`
  grid-column: span 2;
  margin-top: -50px;
  overflow: hidden;
  padding: 0 0 231px 0;
  -moz-transform: rotate(-60deg) skewY(30deg);
  -ms-transform: rotate(-60deg) skewY(30deg);
  -o-transform: rotate(-60deg) skewY(30deg);
  -webkit-transform: rotate(-60deg) skewY(30deg);
  transform: rotate(-60deg) skewY(30deg);
  visibility: hidden;
  width: 200px;

  & * {
    visibility: visible;
  }
  &:hover {
    & .hexagon {
      &:before,
      &:after {
        opacity: 1;
      }
    }
    & .title {
      opacity: 1;
      transform: translate(-50%, -50%) skewY(-30deg) rotate(60deg) scale(1);
      & h2 {
        opacity: 1;
      }
    }
  }
  &:focus-within {
    filter: drop-shadow(0 0 0.75rem var(--dark-green));
    & .hexagon {
      &:before,
      &:after {
        opacity: 1;
      }
    }
    & .title {
      opacity: 1;
      transform: translate(-50%, -50%) skewY(-30deg) rotate(60deg) scale(1);
      & h2 {
        opacity: 1;
      }
    }
  }
  @media only screen and (min-width: 850px) {
    &:nth-child(7n + 1) {
      grid-column-start: 2;
    }
    &:nth-child(7n + 2) {
      grid-column-start: 4;
    }
    &:nth-child(7n + 3) {
      grid-column-start: 6;
    }
    &:nth-child(7n + 4) {
      grid-column-start: 1;
    }
    &:nth-child(7n + 5) {
      grid-column-start: 3;
    }
    &:nth-child(7n + 6) {
      grid-column-start: 5;
    }
    &:nth-child(7n) {
      grid-column-start: 7;
    }
  }
  @media only screen and (max-width: 850px) {
    &:nth-child(5n + 1) {
      grid-column-start: 1;
    }
    &:nth-child(5n + 2) {
      grid-column-start: 3;
    }
    &:nth-child(5n + 3) {
      grid-column-start: 5;
    }
    &:nth-child(5n + 4) {
      grid-column-start: 2;
    }
    &:nth-child(5n) {
      grid-column-start: 4;
    }
  }
  @media only screen and (max-width: 720px) {
    &:nth-child(3n + 1) {
      grid-column-start: 1;
    }
    &:nth-child(3n + 2) {
      grid-column-start: 3;
    }
    &:nth-child(3n) {
      grid-column-start: 2;
    }
  }
  @media only screen and (max-width: 600px) {
    &:nth-child(3n + 1) {
      grid-column-start: 1;
    }
    &:nth-child(3n + 2) {
      grid-column-start: 3;
    }
    &:nth-child(3n) {
      grid-column-start: 2;
    }
  }
  @media only screen and (max-width: 400px) {
    height: 150px;
    margin-bottom: 75px;
    min-height: 150px;
    padding: 0px;
    transform: none;
    width: 50%;
  }
`;
const Hexagon = styled.div`
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  -o-transform: skewY(-30deg) rotate(60deg);
  -moz-transform: skewY(-30deg) rotate(60deg);
  -webkit-transform: skewY(-30deg) rotate(60deg);
  -ms-transform: skewY(-30deg) rotate(60deg);
  transform: skewY(-30deg) rotate(60deg);
  width: 100%;

  &:before,
  &:after {
    bottom: 0;
    content: "";
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 0.5s;
  }
  &:before {
    background: rgba(0, 0, 0, 0.6);
  }
  &:after {
    background: linear-gradient(
      to top,
      transparent,
      rgba(0, 0, 0, 0.5),
      transparent
    );
  }
  @media only screen and (max-width: 400px) {
    background-size: cover;
    position: relative;
    transform: none;
  }
`;
const TitleWrapper = styled.div`
  backface-visibility: hidden;
  color: white;
  font-family: "Cera Pro", "Trebuchet MS", sans-serif;
  font-size: 14px;
  font-weight: 100;
  left: 50%;
  line-height: 20pt;
  margin: 0 auto;
  opacity: 0;
  padding: 0px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  transition: all 0.5s;
  width: 100%;
  will-change: transform;
`;
const Title = styled.h2`
  &:before,
  &:after {
    background: turquoise;
    content: "";
    display: inline-block;
    height: 0.03em;
    margin: 0 0.5em;
    transition: all 0.3s;
    vertical-align: middle;
    width: 0.5em;
  }
`;
interface SiteProps {
  background: string;
  title: string;
  url: string;
}

const PortfolioItems = () => {
  // console.log(data)
  // const image = getImage(data)
  // console.log(image)
  return (
    <Container className="portfolio-container">
      {sites.map((item: SiteProps, index: number) => (
        <SiteItem className="item" key={index}>
          <Link
            href={item.url}
            rel="noopener noreferrer"
            target="_blank"
            aria-label={`Visit ${item.title} website`}
          >
            {/* <StaticImage src={item.background} alt={item.title} /> */}
            <Hexagon
              className="hexagon"
              style={{ backgroundImage: "url(" + item.background + ")" }}
            ></Hexagon>
            <TitleWrapper className="title">
              <Title>{item.title}</Title>
            </TitleWrapper>
          </Link>
        </SiteItem>
      ))}
    </Container>
  );
};

export default PortfolioItems;
